<ng-container *ngIf="visible && summary">
  <div class="card mt-4">
    <h4 class="card-header card-title">
      {{ settings.title || 'AI tutor' }} <small class="text-muted ms-2">{{ summary.from }} – {{ summary.to }}</small>
    </h4>
    <div class="card-body">
      <div class="row">
        <div class="col-6 col-xl-3">
          <div class="text-muted">Tutor requests</div>
          <h2>{{ summary.totals.requests }}</h2>
        </div>
        <div class="col-6 col-xl-3">
          <div class="text-muted">Answered</div>
          <h2>{{ percent(summary.totals.answered, summary.totals.requests) }}</h2>
          <div class="small text-muted">
            not covered {{ percent(summary.totals.notCovered, summary.totals.requests) }} · errors
            {{ percent(summary.totals.errors, summary.totals.requests) }}
          </div>
        </div>
        <div class="col-6 col-xl-3">
          <div class="text-muted">Learners using the tutor</div>
          <h2>{{ summary.learnersHidden ? '< 5' : summary.totals.learners }}</h2>
        </div>
        <div class="col-6 col-xl-3">
          <div class="text-muted">AI cost</div>
          <h2>{{ usd(summary.totals.costMicros) }}</h2>
          <div class="small text-muted" *ngIf="summary.totals.requests > 0">
            {{ usd(summary.totals.costMicros / summary.totals.requests) }} / request
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card mt-4" *ngIf="modules.length">
    <h4 class="card-header card-title">AI tutor by module</h4>
    <div class="card-body table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Module</th>
            <th class="text-end">Requests</th>
            <th class="text-end">Questions</th>
            <th class="text-end">Summaries</th>
            <th class="text-end">Simplify</th>
            <th class="text-end">Answered</th>
            <th class="text-end">Not covered</th>
            <th class="text-end">Errors</th>
            <th class="text-end">Ø time</th>
            <th class="text-end">p95 time</th>
            <th class="text-end">Cost</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let m of shownModules">
            <td class="module" [title]="moduleName(m.module)">{{ moduleName(m.module) }}</td>
            <td class="text-end">{{ m.requests }}</td>
            <td class="text-end">{{ m.questions }}</td>
            <td class="text-end">{{ m.summaries }}</td>
            <td class="text-end">{{ m.simplifications }}</td>
            <td class="text-end">{{ percent(m.answered, m.requests) }}</td>
            <td class="text-end">{{ percent(m.notCovered, m.requests) }}</td>
            <td class="text-end">{{ percent(m.errors, m.requests) }}</td>
            <td class="text-end">{{ seconds(m.avgLatencyMs) }}</td>
            <td class="text-end">{{ seconds(m.p95LatencyMs) }}</td>
            <td class="text-end">{{ usd(m.costMicros) }}</td>
          </tr>
        </tbody>
      </table>
      <button class="btn btn-sm btn-outline-primary" *ngIf="modules.length > 20" (click)="showAll = !showAll">
        {{ showAll ? 'Show top 20' : 'Show all ' + modules.length }}
      </button>
    </div>
  </div>
</ng-container>
